import React, { useState, useEffect, useRef } from 'react';
import {
    FaSearch, FaGavel, FaCalculator, FaUsers, FaChartBar, FaFileAlt,
    FaUniversity, FaHeartbeat, FaBullhorn, FaLaptop, FaProjectDiagram,
    FaCertificate, FaBook, FaAward, FaUserGraduate, FaGlobe, FaHome,
    FaDownload, FaArrowRight, FaCheckCircle, FaStar
} from 'react-icons/fa';
import Footer from '../components/Footer';
import Header from '../components/Header';

const OurFormations = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedDomain, setSelectedDomain] = useState('all');
    const [visibleSections, setVisibleSections] = useState(new Set());

    // Intersection Observer pour animations
    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -100px 0px'
        };

        const observerCallback = (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    setVisibleSections(prev => new Set([...prev, entry.target.dataset.section]));
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);
        document.querySelectorAll('[data-section]').forEach(section => {
            observer.observe(section);
        });

        return () => observer.disconnect();
    }, []);

    const domains = [
        {
            id: 'juridique',
            title: 'Gestion Juridique & Marchés Publics',
            icon: FaGavel,
            color: '#fd7e14',
            description: 'Formations en droit des affaires, marchés publics et conformité juridique',
            formations: 45,
            image: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=600&q=80'
        },
        {
            id: 'finance',
            title: 'Comptabilité - Finance & Management',
            icon: FaCalculator,
            color: '#198754',
            description: 'Expertise comptable, gestion financière et pilotage d\'entreprise',
            formations: 52,
            image: 'https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=600&q=80'
        },
        {
            id: 'rh',
            title: 'Droit Social & Richesses Humaines',
            icon: FaUsers,
            color: '#8b5cf6',
            description: 'Gestion RH, droit du travail et développement des talents',
            formations: 38,
            image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&q=80'
        },
        {
            id: 'audit',
            title: 'Audit - Contrôle de Gestion - Études',
            icon: FaChartBar,
            color: '#dc3545',
            description: 'Audit interne, contrôle de gestion et analyses stratégiques',
            formations: 41,
            image: 'https://images.unsplash.com/photo-1551836022-deb4988cc6c0?w=600&q=80'
        },
        {
            id: 'secretariat',
            title: 'Secrétariat et Administration',
            icon: FaFileAlt,
            color: '#20c997',
            description: 'Techniques de secrétariat moderne et gestion administrative',
            formations: 28,
            image: 'https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?w=600&q=80'
        },
        {
            id: 'banque',
            title: 'Banque - Assurance - FinTech',
            icon: FaUniversity,
            color: '#fbbf24',
            description: 'Services financiers, assurances et technologies financières',
            formations: 36,
            image: 'https://images.unsplash.com/photo-1559526324-593bc073d938?w=600&q=80'
        },
        {
            id: 'sante',
            title: 'Santé - Environnement - Agriculture',
            icon: FaHeartbeat,
            color: '#10b981',
            description: 'Gestion de la santé, développement durable et agriculture',
            formations: 33,
            image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600&q=80'
        },
        {
            id: 'marketing',
            title: 'Marketing - Communication - Tourisme',
            icon: FaBullhorn,
            color: '#f97316',
            description: 'Marketing digital, communication et management hôtelier',
            formations: 44,
            image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=600&q=80'
        },
        {
            id: 'informatique',
            title: 'Gestion Informatique',
            icon: FaLaptop,
            color: '#06b6d4',
            description: 'Développement, cybersécurité et transformation digitale',
            formations: 48,
            image: 'https://images.unsplash.com/photo-1517694712202-14dd9538aa97?w=600&q=80'
        },
        {
            id: 'projet',
            title: 'Gestion de Projet - Gouvernance',
            icon: FaProjectDiagram,
            color: '#8b5cf6',
            description: 'Management de projets et gouvernance publique',
            formations: 39,
            image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&q=80'
        },
        {
            id: 'certifications',
            title: 'Certifications Internationales',
            icon: FaCertificate,
            color: '#dc3545',
            description: 'Certifications PECB et diplômes reconnus mondialement',
            formations: 25,
            image: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=600&q=80'
        }
    ];

    const reasons = [
        {
            icon: FaBook,
            title: 'Actualiser ses Connaissances',
            description: 'CINEF met à votre disposition des formations professionnelles continues en présentiel, en e-learning et en blended learning',
            color: '#fd7e14'
        },
        {
            icon: FaCertificate,
            title: 'Un Certificat de Formation',
            description: 'Recevez à la fin de toutes vos formations CINEF, un certificat ou attestation de compétences',
            color: '#198754'
        },
        {
            icon: FaUsers,
            title: 'Une Large Audience',
            description: 'Les formations en présentiel de CINEF constituent le meilleur moyen de découvrir des acteurs du même domaine d\'activité que vous',
            color: '#8b5cf6'
        },
        {
            icon: FaHome,
            title: 'Apprendre depuis chez Soi',
            description: 'CINEF E-learning est la meilleure solution en matière de formation professionnelle continue',
            color: '#20c997'
        }
    ];

    const filteredDomains = domains.filter(domain => {
        if (selectedDomain !== 'all' && domain.id !== selectedDomain) return false;
        if (searchTerm && !domain.title.toLowerCase().includes(searchTerm.toLowerCase())) return false;
        return true;
    });

    const totalFormations = domains.reduce((sum, domain) => sum + domain.formations, 0);

    return (
        <>
        <Header />
        <div className="formations-wrapper">
            {/* Hero Section */}
            <section className="formations-hero">
                <div className="hero-overlay"></div>
                <div className="formations-container">
                    <div className="hero-content-centered">
                        <div className="hero-badge">
                            <FaAward className="badge-icon-spin" />
                            <span>Plus de {totalFormations} formations disponibles</span>
                        </div>

                        <h1 className="hero-title-main">
                            Découvrez nos <br />
                            <span className="gradient-text-main">Domaines de formation</span>
                        </h1>

                        <p className="hero-description-main">
                            11 domaines d'expertise pour développer vos compétences professionnelles
                            avec des formations certifiantes reconnues internationalement.
                        </p>

                        {/* Search Bar */}
                        <div className="search-section">
                            <div className="search-container-modern">
                                <FaSearch className="search-icon-main" />
                                <input
                                    type="text"
                                    placeholder="Rechercher une formation, un domaine..."
                                    className="search-input-main"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                <button className="search-button-main">
                                    Rechercher
                                </button>
                            </div>

                            {/* Quick Filters */}
                            <div className="quick-filters">
                                <button
                                    className={`filter-chip ${selectedDomain === 'all' ? 'active' : ''}`}
                                    onClick={() => setSelectedDomain('all')}
                                >
                                    Tous les domaines
                                </button>
                                {domains.slice(0, 5).map(domain => (
                                    <button
                                        key={domain.id}
                                        className={`filter-chip ${selectedDomain === domain.id ? 'active' : ''}`}
                                        onClick={() => setSelectedDomain(domain.id)}
                                    >
                                        {domain.title.split(' ')[0]}
                                    </button>
                                ))}
                            </div>
                        </div>

                        <div className="hero-actions">
                            <button className="btn-download">
                                <FaDownload />
                                Télécharger le Catalogue 2025
                            </button>
                            <a href="#domaines" className="btn-explore">
                                Explorer les Formations
                                <FaArrowRight />
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            {/* Domaines Grid Section */}
            <section
                id="domaines"
                className={`domaines-section ${visibleSections.has('domaines') ? 'visible' : ''}`}
                data-section="domaines"
            >
                <div className="formations-container">
                    <div className="section-header-formations">
                        <div className="section-badge-main">
                            <span className="badge-dot-main"></span>
                            <span>Nos Domaines d'Expertise</span>
                        </div>
                        <h2 className="section-title-formations">
                            Choisissez votre <span className="highlight-text-main">domaine</span>
                        </h2>
                        <p className="section-subtitle-main">
                            {filteredDomains.length} domaine{filteredDomains.length > 1 ? 's' : ''} disponible{filteredDomains.length > 1 ? 's' : ''}
                        </p>
                    </div>

                    <div className="domaines-grid">
                        {filteredDomains.map((domain, index) => {
                            const Icon = domain.icon;
                            return (
                                <div
                                    key={domain.id}
                                    className="domain-card-modern"
                                    style={{ '--domain-color': domain.color }}
                                >
                                    <div className="domain-image-wrapper">
                                        <img src={domain.image} alt={domain.title} className="domain-image" />
                                        <div className="domain-overlay-gradient"></div>
                                        <div className="domain-badge-formations">
                                            {domain.formations} formations
                                        </div>
                                    </div>

                                    <div className="domain-content-main">
                                        <div className="domain-icon-main">
                                            <Icon />
                                        </div>

                                        <h3 className="domain-title-main">{domain.title}</h3>
                                        <p className="domain-description-main">{domain.description}</p>

                                        <button className="domain-btn-main">
                                            Voir les formations
                                            <FaArrowRight />
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    {filteredDomains.length === 0 && (
                        <div className="no-results">
                            <FaSearch className="no-results-icon" />
                            <h3>Aucun domaine trouvé</h3>
                            <p>Essayez de modifier vos critères de recherche</p>
                            <button onClick={() => { setSearchTerm(''); setSelectedDomain('all'); }} className="btn-reset">
                                Réinitialiser les filtres
                            </button>
                        </div>
                    )}
                </div>
            </section>

            {/* 4 Bonnes Raisons Section */}
            <section
                className={`reasons-section ${visibleSections.has('reasons') ? 'visible' : ''}`}
                data-section="reasons"
            >
                <div className="formations-container">
                    <div className="section-header-formations">
                        <div className="section-badge-main centered">
                            <span className="badge-dot-main"></span>
                            <span>Pourquoi nous choisir</span>
                        </div>
                        <h2 className="section-title-formations centered">
                            Quatre (04) bonnes raisons <br />
                            <span className="highlight-text-main">de Nous Choisir</span>
                        </h2>
                    </div>

                    <div className="reasons-grid-main">
                        {reasons.map((reason, index) => {
                            const Icon = reason.icon;
                            return (
                                <div
                                    key={index}
                                    className="reason-card-modern"
                                    style={{ '--reason-color': reason.color }}
                                >
                                    <div className="reason-icon-wrapper">
                                        <Icon />
                                    </div>
                                    <h3 className="reason-title-main">{reason.title}</h3>
                                    <p className="reason-description-main">{reason.description}</p>
                                    <div className="reason-checkmark">
                                        <FaCheckCircle />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* CTA Assistance Section */}
            <section
                className={`cta-assistance ${visibleSections.has('cta') ? 'visible' : ''}`}
                data-section="cta"
            >
                <div className="formations-container">
                    <div className="cta-box-modern">
                        <div className="cta-icon-box">
                            <FaUserGraduate />
                        </div>
                        <div className="cta-text-content">
                            <h3>Besoin d'Assistance ou de Conseils en Gestion ?</h3>
                            <p>Notre équipe d'experts est à votre disposition pour vous accompagner</p>
                        </div>
                        <button className="cta-btn-assistance">
                            Cliquez ici
                            <FaArrowRight />
                        </button>
                    </div>
                </div>
            </section>

            {/* Stats Section */}
            {/* <section className="stats-band">
                <div className="formations-container">
                    <div className="stats-grid-main">
                        <div className="stat-item-main">
                            <div className="stat-icon-main"><FaBook /></div>
                            <div className="stat-number-main">{totalFormations}+</div>
                            <div className="stat-label-main">Formations</div>
                        </div>
                        <div className="stat-item-main">
                            <div className="stat-icon-main"><FaGlobe /></div>
                            <div className="stat-number-main">6</div>
                            <div className="stat-label-main">Pays</div>
                        </div>
                        <div className="stat-item-main">
                            <div className="stat-icon-main"><FaAward /></div>
                            <div className="stat-number-main">15+</div>
                            <div className="stat-label-main">Ans d'Expérience</div>
                        </div>
                        <div className="stat-item-main">
                            <div className="stat-icon-main"><FaStar /></div>
                            <div className="stat-number-main">95%</div>
                            <div className="stat-label-main">Satisfaction</div>
                        </div>
                    </div>
                </div>
            </section> */}

            <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .formations-wrapper {
          font-family: 'Inter', sans-serif;
          background: #fafafa;
          overflow-x: hidden;
        }

        .formations-container {
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 24px;
        }

        /* Animations au Scroll */
        section {
          opacity: 0;
          transform: translateY(50px);
          transition: opacity 0.8s ease-out, transform 0.8s ease-out;
        }

        section.visible, .formations-hero {
          opacity: 1;
          transform: translateY(0);
        }

        /* Hero Section */
        .formations-hero {
          min-height: 75vh;
          display: flex;
          align-items: center;
          background: linear-gradient(135deg, #1a202c 0%, #2d3748 100%);
          padding: 120px 0 80px;
          position: relative;
          overflow: hidden;
        }

        .hero-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=1600&q=80') center/cover;
          opacity: 0.15;
        }

        .hero-overlay::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, rgba(253, 126, 20, 0.1) 0%, rgba(220, 53, 69, 0.1) 100%);
        }

        .hero-content-centered {
          text-align: center;
          position: relative;
          z-index: 1;
          max-width: 1000px;
          margin: 0 auto;
        }

        .hero-badge {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          padding: 12px 28px;
          border-radius: 50px;
          margin-bottom: 28px;
          border: 1px solid rgba(255, 255, 255, 0.2);
          animation: fadeInDown 0.8s ease-out;
        }

        @keyframes fadeInDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .badge-icon-spin {
          color: #fd7e14;
          font-size: 20px;
          animation: rotate 3s linear infinite;
        }

        @keyframes rotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        .hero-badge span {
          font-size: 15px;
          font-weight: 700;
          color: white;
        }

        .hero-title-main {
          font-size: 64px;
          font-weight: 900;
          line-height: 1.1;
          color: white;
          margin-bottom: 24px;
          animation: fadeInUp 0.8s ease-out 0.2s backwards;
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .gradient-text-main {
          background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .hero-description-main {
          font-size: 20px;
          line-height: 1.7;
          color: rgba(255, 255, 255, 0.9);
          margin-bottom: 48px;
          animation: fadeInUp 0.8s ease-out 0.4s backwards;
        }

        /* Search Section */
        .search-section {
          margin-bottom: 40px;
          animation: fadeInUp 0.8s ease-out 0.6s backwards;
        }

        .search-container-modern {
          display: flex;
          align-items: center;
          background: white;
          border-radius: 16px;
          padding: 8px 8px 8px 24px;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
          max-width: 700px;
          margin: 0 auto 24px;
        }

        .search-icon-main {
          font-size: 22px;
          color: #6b7280;
          margin-right: 16px;
        }

        .search-input-main {
          flex: 1;
          border: none;
          background: transparent;
          font-size: 16px;
          color: #1a202c;
          outline: none;
          font-family: inherit;
        }

        .search-input-main::placeholder {
          color: #9ca3af;
        }

        .search-button-main {
          background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
          color: white;
          border: none;
          padding: 14px 32px;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s ease;
          font-family: inherit;
        }

        .search-button-main:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(253, 126, 20, 0.4);
        }

        /* Quick Filters */
        .quick-filters {
          display: flex;
          gap: 12px;
          justify-content: center;
          flex-wrap: wrap;
        }

        .filter-chip {
          padding: 10px 20px;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.2);
          color: white;
          border-radius: 50px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          font-family: inherit;
        }

        .filter-chip:hover {
          background: rgba(255, 255, 255, 0.2);
          transform: translateY(-2px);
        }

        .filter-chip.active {
          background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
          border-color: transparent;
          box-shadow: 0 8px 20px rgba(253, 126, 20, 0.4);
        }

        /* Hero Actions */
        .hero-actions {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
          animation: fadeInUp 0.8s ease-out 0.8s backwards;
        }

        .btn-download, .btn-explore {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 16px 32px;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 700;
          cursor: pointer;
          border: none;
          text-decoration: none;
          transition: all 0.3s ease;
          font-family: inherit;
        }

        .btn-download {
          background: white;
          color: #fd7e14;
          box-shadow: 0 10px 30px rgba(255, 255, 255, 0.2);
        }

        .btn-download:hover {
          transform: translateY(-4px);
          box-shadow: 0 15px 40px rgba(255, 255, 255, 0.3);
        }

        .btn-explore {
          background: transparent;
          color: white;
          border: 2px solid white;
        }

        .btn-explore:hover {
          background: white;
          color: #fd7e14;
          transform: translateY(-4px);
        }

        /* Domaines Section */
        .domaines-section {
          padding: 100px 0;
          background: white;
        }

        .section-header-formations {
          text-align: center;
          margin-bottom: 60px;
        }

        .section-badge-main {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          background: linear-gradient(135deg, #fff5f0 0%, #fef3c7 100%);
          padding: 8px 20px;
          border-radius: 50px;
          margin-bottom: 20px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
        }

        .section-badge-main.centered {
          margin: 0 auto 20px;
        }

        .badge-dot-main {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: linear-gradient(135deg, #fd7e14, #dc3545);
          animation: pulse 2s ease-in-out infinite;
        }

        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.3); opacity: 0.7; }
        }

        .section-badge-main span:last-child {
          font-size: 14px;
          font-weight: 600;
          color: #374151;
        }

        .section-title-formations {
          font-size: 48px;
          font-weight: 900;
          color: #111827;
          margin-bottom: 16px;
          line-height: 1.2;
        }

        .section-title-formations.centered {
          text-align: center;
        }

        .highlight-text-main {
          background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .section-subtitle-main {
          font-size: 18px;
          color: #6b7280;
          font-weight: 600;
        }

        /* Domaines Grid */
        .domaines-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 32px;
        }

        .domain-card-modern {
          background: white;
          border-radius: 24px;
          overflow: hidden;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          border: 2px solid transparent;
        }

        .domain-card-modern:hover {
          transform: translateY(-12px);
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
          border-color: var(--domain-color);
        }

        .domain-image-wrapper {
          position: relative;
          height: 200px;
          overflow: hidden;
        }

        .domain-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s ease;
        }

        .domain-card-modern:hover .domain-image {
          transform: scale(1.1);
        }

        .domain-overlay-gradient {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.7) 100%);
        }

        .domain-badge-formations {
          position: absolute;
          top: 16px;
          right: 16px;
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          padding: 8px 16px;
          border-radius: 50px;
          font-size: 13px;
          font-weight: 700;
          color: var(--domain-color);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }

        .domain-content-main {
          padding: 32px;
        }

        /* Suite du CSS pour OurFormations.jsx */

.domain-icon-main {
  width: 60px;
  height: 60px;
  background: var(--domain-color);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 28px;
  margin-bottom: 20px;
  transition: all 0.3s ease;
}

.domain-card-modern:hover .domain-icon-main {
  transform: scale(1.1) rotate(-5deg);
}

.domain-title-main {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 12px;
  line-height: 1.3;
}

.domain-description-main {
  font-size: 15px;
  color: #6b7280;
  line-height: 1.6;
  margin-bottom: 24px;
}

.domain-btn-main {
  display: flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  color: var(--domain-color);
  border: 2px solid var(--domain-color);
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
  width: 100%;
  justify-content: center;
}

.domain-btn-main:hover {
  background: var(--domain-color);
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

/* No Results */
.no-results {
  text-align: center;
  padding: 80px 32px;
  background: white;
  border-radius: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
}

.no-results-icon {
  font-size: 64px;
  color: #e5e7eb;
  margin-bottom: 24px;
}

.no-results h3 {
  font-size: 28px;
  font-weight: 700;
  color: #374151;
  margin-bottom: 12px;
}

.no-results p {
  font-size: 16px;
  color: #6b7280;
  margin-bottom: 32px;
}

.btn-reset {
  padding: 14px 32px;
  background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.btn-reset:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(253, 126, 20, 0.4);
}

/* Reasons Section */
.reasons-section {
  padding: 100px 0;
  background: linear-gradient(135deg, #fafafa 0%, #f8f9fa 100%);
}

.reasons-grid-main {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;
}

.reason-card-modern {
  background: white;
  padding: 40px 32px;
  border-radius: 24px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  border: 2px solid transparent;
}

.reason-card-modern:hover {
  transform: translateY(-12px);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  border-color: var(--reason-color);
}

.reason-icon-wrapper {
  width: 80px;
  height: 80px;
  margin: 0 auto 24px;
  background: linear-gradient(135deg, var(--reason-color), var(--reason-color));
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 36px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
  opacity: 0.9;
}

.reason-card-modern:hover .reason-icon-wrapper {
  transform: scale(1.1) rotate(-10deg);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
}

.reason-title-main {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin-bottom: 16px;
  line-height: 1.3;
}

.reason-description-main {
  font-size: 15px;
  color: #6b7280;
  line-height: 1.7;
  margin-bottom: 20px;
}

.reason-checkmark {
  display: flex;
  justify-content: center;
  color: var(--reason-color);
  font-size: 24px;
  opacity: 0;
  transform: scale(0);
  transition: all 0.3s ease;
}

.reason-card-modern:hover .reason-checkmark {
  opacity: 1;
  transform: scale(1);
}

/* CTA Assistance */
.cta-assistance {
  padding: 80px 0;
  background: white;
}

.cta-box-modern {
  background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
  border-radius: 24px;
  padding: 60px 48px;
  display: flex;
  align-items: center;
  gap: 40px;
  box-shadow: 0 20px 60px rgba(253, 126, 20, 0.3);
  position: relative;
  overflow: hidden;
}

.cta-box-modern::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -20%;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
  border-radius: 50%;
  animation: floatBubble 15s ease-in-out infinite;
}

@keyframes floatBubble {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(30px, -30px) scale(1.1); }
}

.cta-icon-box {
  width: 100px;
  height: 100px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 48px;
  flex-shrink: 0;
  position: relative;
  z-index: 1;
}

.cta-text-content {
  flex: 1;
  position: relative;
  z-index: 1;
}

.cta-text-content h3 {
  font-size: 28px;
  font-weight: 800;
  color: white;
  margin-bottom: 8px;
}

.cta-text-content p {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.9);
}

.cta-btn-assistance {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 36px;
  background: white;
  color: #fd7e14;
  border: none;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  flex-shrink: 0;
  position: relative;
  z-index: 1;
}

.cta-btn-assistance:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.3);
}

/* Stats Band */
.stats-band {
  padding: 80px 0;
  background: linear-gradient(135deg, #1a202c 0%, #2d3748 100%);
}

.stats-grid-main {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 48px;
}

.stat-item-main {
  text-align: center;
  padding: 32px 24px;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.4s ease;
}

.stat-item-main:hover {
  transform: translateY(-10px);
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(253, 126, 20, 0.5);
  box-shadow: 0 12px 40px rgba(253, 126, 20, 0.2);
}

.stat-icon-main {
  width: 60px;
  height: 60px;
  margin: 0 auto 20px;
  background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 28px;
  box-shadow: 0 8px 20px rgba(253, 126, 20, 0.3);
}

.stat-number-main {
  font-size: 48px;
  font-weight: 900;
  color: white;
  margin-bottom: 8px;
  line-height: 1;
}

.stat-label-main {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 600;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .hero-title-main {
    font-size: 52px;
  }

  .domaines-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .reasons-grid-main {
    grid-template-columns: repeat(2, 1fr);
  }

  .stats-grid-main {
    grid-template-columns: repeat(2, 1fr);
    gap: 32px;
  }

  .cta-box-modern {
    flex-direction: column;
    text-align: center;
    padding: 48px 32px;
  }

  .section-title-formations {
    font-size: 40px;
  }
}

@media (max-width: 768px) {
  .formations-hero {
    padding: 100px 0 60px;
    min-height: 70vh;
  }

  .hero-title-main {
    font-size: 42px;
  }

  .hero-description-main {
    font-size: 18px;
  }

  .search-container-modern {
    flex-direction: column;
    gap: 12px;
    padding: 20px;
  }

  .search-button-main {
    width: 100%;
  }

  .quick-filters {
    flex-direction: column;
  }

  .filter-chip {
    width: 100%;
    justify-content: center;
  }

  .hero-actions {
    flex-direction: column;
  }

  .btn-download, .btn-explore {
    width: 100%;
    justify-content: center;
  }

  .domaines-grid {
    grid-template-columns: 1fr;
  }

  .reasons-grid-main {
    grid-template-columns: 1fr;
  }

  .stats-grid-main {
    grid-template-columns: 1fr;
  }

  .section-title-formations {
    font-size: 32px;
  }

  .cta-box-modern {
    padding: 40px 24px;
  }

  .cta-text-content h3 {
    font-size: 24px;
  }

  .cta-btn-assistance {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 640px) {
  .formations-container {
    padding: 0 16px;
  }

  .hero-title-main {
    font-size: 32px;
  }

  .hero-description-main {
    font-size: 16px;
  }

  .search-container-modern {
    padding: 16px;
  }

  .domain-content-main {
    padding: 24px;
  }

  .reason-card-modern {
    padding: 32px 24px;
  }

  .stat-number-main {
    font-size: 36px;
  }
}

/* Animations supplémentaires */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.domain-card-modern {
  animation: scaleIn 0.6s ease-out backwards;
}

.domain-card-modern:nth-child(1) { animation-delay: 0.1s; }
.domain-card-modern:nth-child(2) { animation-delay: 0.2s; }
.domain-card-modern:nth-child(3) { animation-delay: 0.3s; }
.domain-card-modern:nth-child(4) { animation-delay: 0.15s; }
.domain-card-modern:nth-child(5) { animation-delay: 0.25s; }
.domain-card-modern:nth-child(6) { animation-delay: 0.35s; }
.domain-card-modern:nth-child(7) { animation-delay: 0.2s; }
.domain-card-modern:nth-child(8) { animation-delay: 0.3s; }
.domain-card-modern:nth-child(9) { animation-delay: 0.4s; }
.domain-card-modern:nth-child(10) { animation-delay: 0.25s; }
.domain-card-modern:nth-child(11) { animation-delay: 0.35s; }

.reason-card-modern {
  animation: fadeInUp 0.6s ease-out backwards;
}

.reason-card-modern:nth-child(1) { animation-delay: 0.1s; }
.reason-card-modern:nth-child(2) { animation-delay: 0.2s; }
.reason-card-modern:nth-child(3) { animation-delay: 0.3s; }
.reason-card-modern:nth-child(4) { animation-delay: 0.4s; }

.stat-item-main {
  animation: fadeInUp 0.6s ease-out backwards;
}

.stat-item-main:nth-child(1) { animation-delay: 0.1s; }
.stat-item-main:nth-child(2) { animation-delay: 0.2s; }
.stat-item-main:nth-child(3) { animation-delay: 0.3s; }
.stat-item-main:nth-child(4) { animation-delay: 0.4s; }

/* Smooth scrolling */
html {
  scroll-behavior: smooth;
}

/* Loading state */
.domain-card-modern.loading {
  opacity: 0.5;
  pointer-events: none;
}

/* Focus states pour accessibilité */
.search-input-main:focus,
.filter-chip:focus,
.domain-btn-main:focus,
.btn-download:focus,
.btn-explore:focus,
.cta-btn-assistance:focus {
  outline: 3px solid rgba(253, 126, 20, 0.5);
  outline-offset: 2px;
}

/* Print styles */
@media print {
  .search-section,
  .hero-actions,
  .cta-box-modern {
    display: none;
  }

  .domain-card-modern {
    page-break-inside: avoid;
  }
}
        `}</style>
        </div>
        <Footer />
        </>
    );
};

export default OurFormations;